export interface FormRule {
    set?: { [key: string]: FormRule },
    any?: Array<FormRule>,
    all?: Array<FormRule>,
    not?: FormRule,
    compare?: Array<any>,
    compareDate?: Array<any>,
    comparison?: Array<any>,
    reduce?: Array<any>,
    equal?: any,
    fallback?: any,
    concat?: Array<any>
};
